<div id="overlay" #overlay>
  <div id="modal-container" [ngClass]="customClass" #modalbody>
    @if (showCross) {
      <span (click)="closeModal()" class="as-panel__close"
        ><i class="fas fa-times"></i
      ></span>
    }
    @if (showManual) {
      <span (click)="openManual()" class="as-panel__manual"
        ><i class="fas fa-question"></i
      ></span>
    }
    <ng-template #modalContainer></ng-template>
  </div>
</div>
